import type { ComponentResolver, SideEffectsInfo } from 'unplugin-vue-components/types';
import { kebabCase } from 'unplugin-vue-components';

export interface TkComponentResolverOptions {
  exclude?: string[];
  /**
   * import style css or scss along with components
   *
   * @default true
   */
  importStyle?: boolean | 'css' | 'less';
  /**
   * @deprecated use `importStyle: 'css'` instead
   */
  importCss?: boolean;
  /**
   * @deprecated use `importStyle: 'less'` instead
   */
  importLess?: boolean;

  /**
   * use commonjs build default false
   */
  cjs?: boolean;
  /**
   * rename package
   *
   * @default 'ant-design-vue'
   */
  packageName?: string;
}

function getSideEffects(compName: string, options: TkComponentResolverOptions): SideEffectsInfo {
  const { importStyle = true, importLess = false } = options;

  if (!importStyle) return;
  const lib = options.cjs ? 'lib' : 'es';
  const packageName = options?.packageName || '@talkwed/component-ui';

  if (importStyle === 'less' || importLess) {
    const styleDir = kebabCase(compName);
    return `${packageName}/${lib}/components/${styleDir}/style/index.less`;
  } else {
    const styleDir = kebabCase(compName);
    return `${packageName}/${lib}/components/${styleDir}/style/index.css`;
  }
}

/**
 * Resolver for Vlib
 *
 * @link https://github.com/aheadcn/talkwed
 */
export function TkComponentResolver(options: TkComponentResolverOptions = {}): ComponentResolver {
  return {
    type: 'component',
    resolve: (name: string) => {
      /**
       * 加载前会扫描所有导出组件存入缓存，
       */
      // console.log('Component ==>' + name);

      if (!options?.exclude?.includes(name) && name.startsWith('Tkc')) {
        // const index = name.indexOf('Tkc');
        const importName = name.substring(3);
        console.log('importName:' + importName);
        const { cjs = false, packageName = '@talkwed/component-ui' } = options;
        const path = `${packageName}/${cjs ? 'lib' : 'es'}`;
        return {
          name: importName,
          from: path,
          sideEffects: getSideEffects(importName, options),
        };

        // return {
        //   name,
        //   from: `@talkwed/component-ui/${moduleType}`,
        //   sideEffects: getSideEffects(kebabCase(name), options),
        // };
      }
    },
  };
}
